import { render, staticRenderFns } from "./PaymentsDrawer.vue?vue&type=template&id=3be2a088&scoped=true"
import script from "./PaymentsDrawer.vue?vue&type=script&lang=js"
export * from "./PaymentsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be2a088",
  null
  
)

export default component.exports